/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
	SVGIcon
} from '@ba/ba-ui-carbon-toolkit';

import warnIcon24 from '@ba/ba-graphics/dist/icons-js/warning--alt_16';

import CardView from './CardView';

class WarningCardView extends Component {
	render() {
		const { id, thumbnail } = this.props;
		const classes = classNames({
			cardThumbnails__item__warning: true
		});

		return (
			<div
				className={classes}>
				{this._renderWarningIcon()}
				<CardView
					id={id}
					thumbnail={thumbnail}
				/>
			</div>

		);
	}

	_renderWarningIcon() {
		return (
			<SVGIcon
				className="cardThumbnails__item__warning__icon"
				iconId={warnIcon24.id}
			/>
		);
	}
}

WarningCardView.propTypes = {
	id: PropTypes.string.isRequired,
	thumbnail: PropTypes.shape({
		type: PropTypes.string,
		widgetId: PropTypes.string
	})
};

export default WarningCardView;



// WEBPACK FOOTER //
// ./src/js/components/cards/views/WarningCardView.js